import themeConfig from '@themeConfig';

 export default ({
  watch: {
    $route() {
      if (this.$store.state.app.windowWidth < themeConfig["$themeBreakpoints"].xl) {
        this.isVerticalMenuActive = false;
      }
    }
  }
});

